<!--尾部-->
<template>
    <div>
        <div class="foot" >
            <div class="foot-container" style="width:1233px;margin:0 auto;background:#1965b5">
                <div>
                    <div style="display:flex">
                        <div style="width:370px">公司地址：上海市嘉定区平城路955弄3号</div>
                        <!-- <div style="width:290px">联系电话：021-59911181</div> -->
                    </div>
                    <div style="display:flex;margin-top:16px">
                        <div style="width:370px">版权所有：上海嘉定住房建设发展（集团）有限公司</div>
                        <div style="width:290px">技术支持：江苏瀚远科技股份有限公司</div>
                        <div style="cursor:pointer" @click="toICP">沪ICP备18002644号-1</div>
                    </div>
                </div>
                <div>
                    <img :src="qR_CODE_PIC" alt="" style="margin:0 auto;width:72px;height:80px;display:block;">
                    <!-- <div class="wx-tip">住房集团微信公众号</div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {  post, get } from "@/api/common/index";
import CryptoJS from "crypto-js";
export default {
    data() {
        return {
            config:config,
            qR_CODE_PIC:require('../../../public/static/imgs/wx.jpg'),
            info:{},
            linkList:[],
            toList:[],
            titleinList:[],
            num:''
        };
    },
    methods:{
        toICP(){
            let a = document.createElement('a')
            a.setAttribute('target','view_window')
            a.href = 'https://beian.miit.gov.cn/#/Integrated/index'
            a.click()
        },
    },
    created(){
    },
    mounted(){
    }
};
</script>
<style scoped>
.foot{
    
}
.foot-container{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 14px;
    padding: 5px 5px 2px 60px; 
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.home-part5{
    width: 1260px;
    margin: 0 auto;
    justify-content:space-between;
    padding: 19px 0;
}
.level{
    display: flex;
    align-items: center;
}
.foot-middle{
    margin-left: 50px;
}
.num-unit{
    padding: 6px;
    font-size: 19px;
    font-weight: bold;
    color: #999999;
    background: #666666;
    margin-right: 5px;
}
.wx-tip{
    font-size: 12px;
    color: #EEEEEE;
    margin-top: 4px;
}
</style>
